import { ReactElement, useState } from "react";
import Image from "next/image";
import Video from "./Video"

interface MediaWithTextProps{
    textInLeft?: boolean;
    imageSrc?: string;
    videoSrc?: string;
    videoThumb?: string;
    heading?: string;
    children?:  ReactElement;
    aspectRatio?: string;
}

export default function MediaWithText(props: MediaWithTextProps){

    return (
        <div className="media-with-text">
            {props.heading && (
                <h2 className="text-center font-light">{props.heading}</h2>
            )}

            <div className={`flex items-start gap-12 mt-8 flex-col ${props.textInLeft ? "xl:flex-row-reverse" : "xl:flex-row" }`}>
                
                <div className={`w-full xl:w-1/2 relative ${props.aspectRatio ?? "" }`}>
                    {props.imageSrc && (
                        <Image
                            src={props.imageSrc ?? ""}
                            title={props.heading ?? ""}
                            alt={props.heading ?? ""}
                            fill
                            className=" "
                        />
                    )}

                    {props.videoSrc && (
                        <Video 
                            videoSrc={props.videoSrc}
                            videoThumb={props.videoThumb}
                        />
                    )}
                </div>

                <div className="w-full xl:w-1/2">
                    {props.children}
                </div>

            </div>
        </div>
    );
}